module.exports = __webpack_public_path__ + "img/bizspring.d8a84127.png";